import { BrowserCacheLocation, Configuration } from '@azure/msal-browser'

// Config object to be passed to Msal on creation
const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID as string,
    authority: process.env.REACT_APP_AZURE_AUTHORITY as string,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  system: {
    asyncPopups: true,
    allowNativeBroker: false, // Disables WAM Broker
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
}

const config = {
  graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT as string,
  restUrl: process.env.REACT_APP_REST_URL as string,
  graphqlRestEndpoint: process.env.REACT_APP_GRAPHQL_REST_ENDPOINT as string,
  motorTrackerUrl: process.env.REACT_APP_MOTOR_TRACKER_URL as string,
  appVersion: process.env.APP_VERSION,
  msalConfig,
}

export default config
